export default "__VITE_ASSET__DDsyXC_N__"